const REGULAR = 'REGULAR';
const OUT_OF_STOCK_MESSAGE = 'Out of Stock';
const SHIPTOHOME = 'Ship to Home';
const SHIPTOSTORE = 'Store';
const SAMEDAYPICKUP_FLAG = 'samedaypickup';
const SAMEDAYPICKUP = 'Same Day Pickup';
const FREEPICKUP = 'Free Pickup';
const SHIPTOHOMEORSTORE = 'ship to home or store';
const NOTAVAILABLE = 'Unavailable';
const NOT_AVAILABLE_SHORT = 'NA';
const DISABLED = 'disabled';
const GETITTODAY = 'Get it Today';
const OUTOFSTOCK = 'Out Of Stock';
const LIMITEDSTOCK = 'Limited Stock';
const pTmplType = 'pTmplType';
const CHECKOUT_URL = '/cart';
const ADD_ITEMS_TO_CART = 'Add ${qty} Item${qty === 1 ? \'\' : \'s\'} to Cart'; // eslint-disable-line
const ADD_TO_CART_SELECTION = 'Select options above to add to cart';
const INVENTORY_UNAVAILABLE = 'Inventory not available';
const STORE_PICKUP_LABEL = 'Check Availability';
const SHOP_ALL = 'Shop all';
const PICKUP_UNAVAILABLE_SELECTED_STORE = 'Unavailable at this store';
const PICKUP_UNAVAILABLE_NEARBY_STORE = 'Not available at nearby stores';
const CHANGE_STORE_BTN = 'change';
const SELECT_A_STORE_BTN = 'Select a Store';
const SHOP_THE_LOOK = 'Shop The Look';
const SHOP_THIS_LOOK = 'SHOP THIS LOOK >';
const SHOP_ATC = 'Shop';
const ADD_TO_CART = 'ADD TO CART';
const DEFAULT = 'DEFAULT';
const CODE = 'with code';
const QUANTITY = 'Quantity';
const SIZE_DIMENSIONS = ['WIDTH', 'SIZE', 'CHEST', 'WAIST'];
const DESCRIPTION_UNAVAILABLE = 'The item combination you have selected is not available';

export default {
    REGULAR,
    OUT_OF_STOCK_MESSAGE,
    SHIPTOHOME,
    SHIPTOSTORE,
    SAMEDAYPICKUP_FLAG,
    SAMEDAYPICKUP,
    FREEPICKUP,
    SHIPTOHOMEORSTORE,
    NOTAVAILABLE,
    NOT_AVAILABLE_SHORT,
    DISABLED,
    GETITTODAY,
    OUTOFSTOCK,
    LIMITEDSTOCK,
    pTmplType,
    CHECKOUT_URL,
    ADD_ITEMS_TO_CART,
    ADD_TO_CART_SELECTION,
    INVENTORY_UNAVAILABLE,
    STORE_PICKUP_LABEL,
    SHOP_ALL,
    PICKUP_UNAVAILABLE_SELECTED_STORE,
    PICKUP_UNAVAILABLE_NEARBY_STORE,
    CHANGE_STORE_BTN,
    SELECT_A_STORE_BTN,
    SHOP_THE_LOOK,
    SHOP_THIS_LOOK,
    SHOP_ATC,
    ADD_TO_CART,
    DEFAULT,
    CODE,
    QUANTITY,
    SIZE_DIMENSIONS,
    DESCRIPTION_UNAVAILABLE,
};

export const productDimensions = { // eslint-disable-line
    SIZE: 'SIZE',
    COLOR: 'COLOR',
    NOTAVAILABLE: 'Not Available',
    LENGTH: 'LENGTH',
};

export const creditCardBannerConst = {
    CREDIT_CARD_BANNER_TYPE: 'cf-product-credit-card-banner',
    creditCardBannerPriceThreshold: 100,
};

export const atcErrorCodes = {
    SRV_PRICE_FALLBACK_FAILED: 'SRV_PRICE_FALLBACK_FAILED',
};

export const PLA_REC_PAGE_TYPE = 'PLAPRODUCT';
export const PRODUCT = 'PRODUCT';
export const HOW_TO_STYLE_IT = 'How to Style It';
